var map = {
	"./": 127,
	"./dev": 301,
	"./dev.ts": 301,
	"./index": 127,
	"./index.ts": 127,
	"./prod": 302,
	"./prod.ts": 302,
	"./test": 303,
	"./test.ts": 303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 427;